import { isFilterValueHasRestrictedPropertiesUsingManualCheck } from '../../../utils/fieldLevelPermissions';
import { isLogicGroupHasAtLeastOneCondition } from '../../../filterQueryFormat/logic/LogicGroup';
import { useContext } from 'react';
import { useInternalValue } from '../../../hooks/useInternalValue';
import { useQuickFiltersInternalValue } from '../../../hooks/useQuickFiltersInternalValue';
import FormattedMessage from 'I18n/components/FormattedMessage';
import QuickFilterSelectBase from './QuickFilterSelectBase';
import SegmentationFiltersInstanceContext from '../../../state/SegmentationFiltersInstanceContext';
import { Button } from 'foundations-components/transitional/components/Button';
import { AdvancedFiltersIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Flex } from 'foundations-components/components/Flex';
import VerticalBar from '../../common/VerticalBar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AdvancedFiltersButton = ({
  advancedFiltersButtonState,
  buttonProperties,
  onClearAdvancedFilters,
  onOpenAdvancedFilters,
  showAdvancedFiltersButton,
  showClearAdvancedFiltersButton
}) => {
  const {
    data,
    fetchMore,
    getIsUngated,
    getTrackerInstance,
    hasScope,
    isUserInfoFetched,
    props: {
      baseFilterFamily,
      strategy,
      quickFilters,
      value
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const advancedFiltersInternalValue = useInternalValue(baseFilterFamily, strategy, value, data, fetchMore, getIsUngated, hasScope, isUserInfoFetched);
  const quickFiltersInternalValue = useQuickFiltersInternalValue(baseFilterFamily, strategy, quickFilters, data, fetchMore, getIsUngated, hasScope, isUserInfoFetched);
  if (!showAdvancedFiltersButton) {
    return null;
  }
  const isActive = !!advancedFiltersInternalValue && isLogicGroupHasAtLeastOneCondition(advancedFiltersInternalValue);
  const isAdvancedFiltersValueRestricted = !!advancedFiltersInternalValue && isFilterValueHasRestrictedPropertiesUsingManualCheck(advancedFiltersInternalValue);
  const isQuickFiltersValueRestricted = !!quickFiltersInternalValue && isFilterValueHasRestrictedPropertiesUsingManualCheck(quickFiltersInternalValue);
  const isRestricted = isAdvancedFiltersValueRestricted || isQuickFiltersValueRestricted;
  const onClick = () => {
    var _getTrackerInstance;
    if (!onOpenAdvancedFilters) {
      return;
    }
    onOpenAdvancedFilters();
    (_getTrackerInstance = getTrackerInstance()) === null || _getTrackerInstance === void 0 || _getTrackerInstance.track('clickedAdvancedFilters', {
      primaryObjectTypeId: baseFilterFamily,
      version: '2'
    });
  };
  const onClear = () => {
    var _getTrackerInstance2;
    if (!onClearAdvancedFilters) {
      return;
    }
    onClearAdvancedFilters();
    (_getTrackerInstance2 = getTrackerInstance()) === null || _getTrackerInstance2 === void 0 || _getTrackerInstance2.track('clearedAdvancedFilters', {
      primaryObjectTypeId: baseFilterFamily,
      version: '2'
    });
  };
  const disabled = isRestricted || (advancedFiltersButtonState === null || advancedFiltersButtonState === void 0 ? void 0 : advancedFiltersButtonState.disabled);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(VerticalBar, {
      marginInlineEnd: "200"
    }), /*#__PURE__*/_jsx(QuickFilterSelectBase, {
      button: /*#__PURE__*/_jsx(Tooltip, {
        disabled: !disabled,
        title: isRestricted ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.restrictedAsset.noViewOrEditAccess"
        }) : advancedFiltersButtonState === null || advancedFiltersButtonState === void 0 ? void 0 : advancedFiltersButtonState.tooltip,
        children: /*#__PURE__*/_jsxs(Button, {
          "data-selenium-test": "FiltersBar-advancedFilters",
          "data-selenium-info": isActive ? 'highlighted' : 'notHighlighted',
          disabled: disabled,
          onClick: onClick,
          size: buttonProperties.BUTTON_SIZE,
          use: buttonProperties.BUTTON_USE,
          children: [/*#__PURE__*/_jsx(AdvancedFiltersIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFiltersUI.quickFiltersBar.advancedFilters"
          })]
        })
      }),
      buttonHeight: buttonProperties.BUTTON_HEIGHT,
      isActive: isActive,
      propertyName: "advancedFilters",
      onValueChange: showClearAdvancedFiltersButton ? onClear : undefined
    })]
  });
};
export default AdvancedFiltersButton;